import { useEffect, useState } from "react";
import { Panel } from "../../../../../components/Panel";
import { PriceInput } from "../../../../../components/PriceInput";
import { CalendarView } from "./CalendarView";
import { Chart } from "./Chart";
import Checkbox from "./Checkbox";
import { SeasonSelect } from "./SeasonSelect";
import { SeasonFormModal } from "./SeasonFormModal";
import Button from "../../../../../components/Button";
import { validateEventsForm } from "../../onboarding/useValidation";
import moment from "moment";
import { api } from "../../../../../helpers/api";
import { commaSeparatedNumber, getUser } from "../../../../../helpers/utils";
import { ConfirmDeleteSeason } from "./ConfirmDeleteSeason";
import { ReactComponent as DeleteIcon } from "../../../../../assets/icons/trash.svg";

// function Checkbox({
//   checked,
//   onChange,
// }: {
//   checked: boolean;
//   onChange: (checked: boolean) => void;
// }) {
//   return (
//     <input
//       type="checkbox"
//       className="w-4 h-4 "
//       onChange={(e) => onChange(e.target.checked)}
//       checked={checked}
//     />
//   );
// }

export function SeasonAndEvents({
  form,
  setForm,
  user,
}: {
  form: any;
  setForm: any;
  user: any;
}) {
  const [showDeleteSeasonModal, setShowDeleteSeasonModal] = useState({
    isOpen: false,
    season: null,
  });
  const [pricesLoading, setPricesLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [season, setSeason] = useState<any>(null);
  const [showSeasonModal, setShowSeasonModal] = useState(false);

  // calendar view
  const [date, setDate] = useState<string | null>(null);
  const [prices, setPrices] = useState<any>({});

  const handleCreateSeason = () => {
    setShowSeasonModal(true);
  };

  const handleCancel = () => {
    if (form?.seasons && form?.seasons.length > 0) {
      setSeason(form?.seasons[0]);
    } else {
      setSeason(null);
    }
  };

  const handleSave = async () => {};

  const handleDeleteSeason = (season) => {
    console.log("season", season);
    setShowDeleteSeasonModal({ isOpen: false, season: null });
    setForm((prev) => {
      const index = prev?.seasons.findIndex((s: any) => s.id === season.id);
      const seasons = prev?.seasons.filter((s: any) => s.id !== season.id);
      const otherSeason =
        seasons[index - 1] || seasons[index + 1] || seasons[0] || null;
      setSeason(otherSeason);
      return {
        ...prev,
        seasons,
      };
    });
  };

  useEffect(() => {
    if (form?.seasons && form?.seasons.length > 0) {
      setSeason(form?.seasons[0]);
    } else {
      setSeason(null);
    }
  }, [form]);

  const fetchPrices = async (date) => {
    try {
      const userId = user?.id;
      setPricesLoading(true);
      // fetch prices
      const dayMetricsResponse = await api.getDayMetrics(userId, {
        type: "Summary",
        date: moment(date).format("YYYY-MM-DD"),
      });
      setPrices({
        adr: dayMetricsResponse?.adr || 0,
        totalRevenue: dayMetricsResponse?.totalRevenue || 0,
        dynamicPrice: dayMetricsResponse?.baseRoomTypeRate || 0,
      });
      setPricesLoading(false);
    } catch (error) {
      setPricesLoading(false);
      console.log("error", error);
    }
  };

  const handleSetDate = (date) => {
    setDate(date);
    fetchPrices(date);
  };

  useEffect(() => {
    if (season && season?.startDate) {
      setDate(season.startDate);
      fetchPrices(season.startDate);
    }
  }, [season?.startDate]);

  const seasons = (form?.seasons || []).map((s: any) => {
    if (season?.id === s.id) {
      return season;
    }
    return s;
  });
  const validation = validateEventsForm({ ...form, seasons });
  return (
    <>
      <div className="flex items-start gap-4">
        <div className="flex-1">
          <Chart seasons={form?.seasons || []} selectedSeason={season} />
          <div className="mt-4">
            <div className="mb-4 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <SeasonSelect
                  season={season}
                  onSeasonChange={(seasonId) => {
                    setSeason(
                      form?.seasons.find((s: any) => s.id === seasonId)
                    );
                  }}
                  list={
                    (form?.seasons || []).map((season: any, index) => ({
                      label: season?.name,
                      value: season?.id || index + 1,
                    })) || []
                  }
                />
                <button
                  onClick={() =>
                    setShowDeleteSeasonModal({ isOpen: true, season })
                  }
                >
                  <DeleteIcon />
                </button>
              </div>
              <button
                className="text-brand-primary text-xs font-medium"
                onClick={handleCreateSeason}
              >
                Create new
              </button>
            </div>
            <table className="w-full relative" cellSpacing={12}>
              <colgroup>
                <col style={{ width: "40%" }} />
                <col style={{ width: "20%" }} />
                <col style={{ width: "20%" }} />
                <col style={{ width: "20%" }} />
              </colgroup>
              <thead className="w-full">
                <tr className="text-neutral-800 bg-neutral-300 [&_td]:text-2xs [&_td]:font-medium [&_td]:py-2.5 ">
                  <td></td>
                  <td className="text-center">Weekday</td>
                  <td className="text-center">Weekend</td>
                  <td className="text-center whitespace-nowrap">Dynamic</td>
                </tr>
              </thead>
              <tbody>
                <tr className="text-2xs font-medium [&_td]:text-content-tertiary [&_td]:py-2  [&_td]:border-b [&_td]:border-b-neutral-300">
                  <td className="tracking-[-0.44px] pl-4">Rate Floor</td>
                  <td className="tracking-[-0.44px] text-right">
                    <div className="flex justify-center w-full">
                      <PriceInput
                        onChange={(value) => {
                          setForm((prev) => {
                            const seasons = prev?.seasons.map((s: any) => {
                              if (s.id === season.id) {
                                return {
                                  ...s,
                                  weekdayPriceFloor: value,
                                };
                              }
                              return s;
                            });
                            return {
                              ...prev,
                              seasons,
                            };
                          });
                        }}
                        value={season?.weekdayPriceFloor}
                        className="w-[66px] !h-6 !text-content-primary"
                        readOnly={season?.isPriceFloorDynamic}
                        disabled={season?.isPriceFloorDynamic}
                      />
                    </div>
                  </td>
                  <td className="tracking-[-0.44px] pr-4">
                    <div className="flex justify-center w-full">
                      <PriceInput
                        onChange={(value) => {
                          setForm((prev) => {
                            const seasons = prev?.seasons.map((s: any) => {
                              if (s.id === season.id) {
                                return {
                                  ...s,
                                  weekendPriceFloor: value,
                                };
                              }
                              return s;
                            });
                            return {
                              ...prev,
                              seasons,
                            };
                          });
                        }}
                        value={season?.weekendPriceFloor}
                        className="w-[66px] !h-6 !text-content-primary"
                        readOnly={season?.isPriceFloorDynamic}
                        disabled={season?.isPriceFloorDynamic}
                      />
                    </div>
                  </td>
                  <td className="tracking-[-0.44px] pr-4">
                    <div className="flex justify-center w-full">
                      <Checkbox
                        checked={season?.isPriceFloorDynamic}
                        onChange={(checked) => {
                          setForm((prev) => {
                            const seasons = prev?.seasons.map((s: any) => {
                              if (s.id === season.id) {
                                return {
                                  ...s,
                                  isPriceFloorDynamic: checked,
                                };
                              }
                              return s;
                            });
                            return {
                              ...prev,
                              seasons,
                            };
                          });
                        }}
                        id="isPriceFloorDynamic"
                      />
                    </div>
                  </td>
                </tr>
                <tr className="text-2xs font-medium [&_td]:text-content-tertiary [&_td]:py-2  [&_td]:border-b [&_td]:border-b-neutral-300">
                  <td className="tracking-[-0.44px] pl-4">Rate Ceiling</td>
                  <td className="tracking-[-0.44px] text-right">
                    <div className="flex justify-center w-full">
                      <PriceInput
                        onChange={(value) => {
                          setForm((prev) => {
                            const seasons = prev?.seasons.map((s: any) => {
                              if (s.id === season.id) {
                                return {
                                  ...s,
                                  priceCeiling: value,
                                };
                              }
                              return s;
                            });
                            return {
                              ...prev,
                              seasons,
                            };
                          });
                        }}
                        value={season?.priceCeiling}
                        className="w-[66px] !h-6 !text-content-primary"
                        readOnly={season?.isPriceCeilingDynamic}
                        disabled={season?.isPriceCeilingDynamic}
                      />
                    </div>
                  </td>
                  <td className="tracking-[-0.44px] pr-4">
                    <div className="flex justify-center w-full">
                      <PriceInput
                        onChange={(value) => {
                          setForm((prev) => {
                            const seasons = prev?.seasons.map((s: any) => {
                              if (s.id === season.id) {
                                return {
                                  ...s,
                                  weekendPriceCeiling: value,
                                };
                              }
                              return s;
                            });
                            return {
                              ...prev,
                              seasons,
                            };
                          });
                        }}
                        value={season?.rateCeiling}
                        className="w-[66px] !h-6 !text-content-primary"
                        placeholder="-"
                        readOnly={season?.isPriceCeilingDynamic}
                        disabled={season?.isPriceCeilingDynamic}
                      />
                    </div>
                  </td>
                  <td className="tracking-[-0.44px] pr-4">
                    <div className="flex justify-center w-full">
                      <Checkbox
                        checked={season?.isPriceCeilingDynamic}
                        onChange={(checked) => {
                          setForm((prev) => {
                            const seasons = prev?.seasons.map((s: any) => {
                              if (s.id === season.id) {
                                return {
                                  ...s,
                                  isPriceCeilingDynamic: checked,
                                };
                              }
                              return s;
                            });
                            return {
                              ...prev,
                              seasons,
                            };
                          });
                        }}
                        id="isPriceCeilingDynamic"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="min-w-[314px] w-[314px]">
          <CalendarView
            user={user}
            season={season}
            prices={prices}
            setPrices={setPrices}
            date={date}
            setDate={handleSetDate}
            pricesLoading={pricesLoading}
          />
        </div>
        {showSeasonModal && (
          <SeasonFormModal
            isOpen={showSeasonModal}
            onClose={() => setShowSeasonModal(false)}
            form={form}
            onUpdate={(updatedForm: any) => {
              setForm(updatedForm);
              setShowSeasonModal(false);
            }}
            user={user}
          />
        )}
      </div>
      {showDeleteSeasonModal.isOpen && (
        <ConfirmDeleteSeason
          onClose={() =>
            setShowDeleteSeasonModal({ isOpen: false, season: null })
          }
          onConfirm={() => handleDeleteSeason(showDeleteSeasonModal.season)}
          season={showDeleteSeasonModal.season}
        />
      )}
    </>
  );
}
